import React, { useEffect, useState } from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import styled from "styled-components";

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 400);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Button
      type="button"
      isVisible={isVisible}
      onClick={scrollToTop}
      aria-label="Scroll to top"
    >
      <KeyboardArrowUpIcon />
    </Button>
  );
};

export default ScrollToTopButton;

const Button = styled.button`
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 45;
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: #00c853;
  border-radius: 50%;
  box-shadow: 0 16px 34px rgba(0, 200, 83, 0.32);
  cursor: pointer;
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  pointer-events: ${(props) => (props.isVisible ? "auto" : "none")};
  transform: translateY(${(props) => (props.isVisible ? "0" : "12px")});
  transition: opacity 0.2s ease, transform 0.2s ease, background 0.2s ease;

  &:hover {
    background: #00b34a;
  }

  @media only screen and (max-width: 480px) {
    right: 14px;
    bottom: 14px;
  }
`;
